module.exports = __webpack_public_path__ + "img/ukraine-logo-icon.799e0c1d.png";